import { ПОВАДКИ } from './species-kinds.js';
export const СЛОЖЕНИЯ = {
    // Лещ, густера, синец: сорокасантиметровый лещ шириной 2.9 см. Тело работает
    // как парус, а не как двигатель — хвостовой стебель узкий, лопасть мягкая.
    ленточное: { полутолщина: 0.036, тяга: 0.62, запас: 0.6, разгон: 0.7 },
    // Окунь, карась, краснопёрка. Замерено на окуне: 0.044.
    высокотелое: { полутолщина: 0.045, тяга: 0.85, запас: 0.85, разгон: 0.85 },
    // Жерех, голавль, уклейка, хариус. Замерено на жерехе: 0.045 — то же, что у
    // окуня, и различает их не толщина, а тяга: узкий стебель и вилка лопасти.
    прогонистое: { полутолщина: 0.045, тяга: 1.15, запас: 1.1, разгон: 1.3 },
    // Щука, судак, лосось, таймень. Замерено на щуке: 0.078. Опорная форма —
    // все поправки равны единице, и от неё отсчитывается остальной стол.
    округлое: { полутолщина: 0.078, тяга: 1, запас: 1, разгон: 1 },
    // Карп, сазан, сом, линь, усач. Полуметровый карп шириной 11.5 см — это и
    // есть карп. Сплошной кусок мяса: запас самый большой, разгон дорогой.
    тучное: { полутолщина: 0.115, тяга: 1.1, запас: 1.3, разгон: 0.75 },
    // Угорь, минога, вьюн: метровый угорь шириной 6 см. Волна по всему телу —
    // способ экономный, но упираться в леску таким телом плохо.
    змеевидное: { полутолщина: 0.03, тяга: 0.8, запас: 1.2, разгон: 0.65 },
};
export const ПАСТИ = {
    // Окунь, лещ, плотва, уклейка, сиг. Замерено обратным ходом с окуня.
    // Тонкая слизистая плёнка: крючок входит от лёгкого движения и её же рвёт.
    плёночная: { резкость: 1.52, держание: 15, окно: 1.3 },
    // Жерех, голавль, чехонь. Замерено с жереха: держит хуже всех, 13 Н, —
    // жереха и правда рвут чаще прочих. Но подсекать надо резче окуня: мяса в
    // пасти мало, а края костяные, крючку не за что зацепиться.
    тонкогубая: { резкость: 1.8, держание: 13, окно: 0.9 },
    // Щука, таймень, кумжа, змееголов. Замерено с щуки: 2.2 и 26. Челюсть
    // окостеневшая, крючок надо ПРОБИТЬ; зато пробитый сидит крепко.
    костистая: { резкость: 2.2, держание: 26, окно: 1 },
    // Судак, берш, ауха. Замерено с судака: 2.5 и 30. Костяные пластины и клыки:
    // самая трудная подсечка и лучшее держание. Берёт коротко и бросает мгновенно.
    панцирная: { резкость: 2.5, держание: 30, окно: 0.8 },
    // Карп, сазан, линь, сом, усач. Резиновая губа: пробивать не надо, надо
    // ПРОТЯНУТЬ. Держит как костяная, потому что рвётся не пробитая дырка, а
    // толстая упругая ткань, и рвётся плохо: карпа теряют по снасти, а не по губе.
    кожистая: { резкость: 1.9, держание: 30, окно: 1.45 },
    // Осетровые, миноги. Выдвижная трубка без зубов: мягкая на вид, но это
    // плотный хрящ. Всасывает и уходит, подсекаясь сама.
    хрящевая: { резкость: 2.3, держание: 34, окно: 1.55 },
};
/**
 * Длина, при которой челюсть уже толще, чем крючок способен взять.
 *
 * ⚠️ ЭТО ОБЪЯСНЯЕТ, ПОЧЕМУ ДЕРЖАНИЕ НЕ РАСТЁТ С ВЕСОМ. Крючок один и тот же —
 * что у окуня, что у щуки, — и глубже, чем он входит, дырка не станет. У рыбы
 * длиннее тридцати сантиметров ткани заведомо больше, чем крючок протыкает, и
 * дальше число упирается в потолок. У мелочи же протыкается насквозь, и держать
 * ей нечем: уклейке достаётся шестая часть от полного числа.
 */
const ПОЛНЫЙ_ЗАЦЕП_М = 0.3;
/**
 * ⚠️ ПОТОЛОК СВЕЧЕК НЕ УКРАШЕНИЕ, А ЗАЩИТА ОТ НЕИГРАБЕЛЬНОГО. В fish.ts
 * замерено прямо: при 0.1 свечки в секунду щука за минуту боя выходила наверх
 * шесть раз и стряхивала приманку ВСЕГДА — взять её было нельзя в принципе.
 * Правило же роняет частоту с массой, а значит у трёхсотграммовой форели легко
 * даёт больше десятой, и она станет непойманной по той же причине.
 */
const СВЕЧКИ_ПОТОЛОК = 0.08;
const ЭТАЛОНЫ = {
    засадный: { kg: 1.4, сложение: 'округлое', пасть: 'костистая', течение: 'слабое', кто: 'щука' },
    угонщик: {
        kg: 0.9,
        сложение: 'прогонистое',
        пасть: 'тонкогубая',
        течение: 'сильное',
        кто: 'жерех',
    },
    // ⚠️ ТЕЧЕНИЕ 'ЛЮБОЕ', А НЕ 'СЛАБОЕ', И ЭТО НЕ МЕЛОЧЬ. Эталон обязан совпадать
    // со ЗАПИСЬЮ вида в справочнике до последнего поля: разойдись хоть в одном —
    // и отношение перестанет быть единицей, а замеренные числа поедут. Здесь оно
    // и поехало: выносливость судака выходила 12.6 вместо 12.
    донный_хищник: {
        kg: 1.1,
        сложение: 'округлое',
        пасть: 'панцирная',
        течение: 'любое',
        кто: 'судак',
    },
    стайная_бель: {
        kg: 0.18,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        течение: 'слабое',
        кто: 'окунь',
    },
    // ⚠️ ЭТАЛОН — ЛЕЩ, И ЧИСЛА ПОВАДКИ ПОД НЕГО ПОПРАВЛЕНЫ. Стояло «сила 1.9,
    // выносливость 20 с» — это числа не леща, а скорее карпа, и именно из-за них
    // двадцать семь видов дрались одинаково.
    крупная_бель: {
        kg: 0.8,
        сложение: 'ленточное',
        пасть: 'плёночная',
        течение: 'слабое',
        кто: 'лещ',
    },
    // ⚠️ НОВАЯ ПОВАДКА, ОТКОЛОТАЯ ОТ «КРУПНОЙ БЕЛИ». Карп и лещ делили одни числа,
    // и главное отличие карповой рыбалки — что карп сопротивляется — просто не
    // существовало: лещ выходил вдвое упорнее, чем должен, карп вдвое слабее.
    карповый_силач: { kg: 3, сложение: 'тучное', пасть: 'кожистая', течение: 'слабое', кто: 'карп' },
    холодолюбивый: {
        kg: 0.5,
        сложение: 'округлое',
        пасть: 'костистая',
        течение: 'сильное',
        кто: 'кумжа',
    },
    осетровый: {
        kg: 2,
        сложение: 'округлое',
        пасть: 'хрящевая',
        течение: 'сильное',
        кто: 'стерлядь',
    },
    мелочь: {
        kg: 0.03,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        течение: 'слабое',
        кто: 'уклейка',
    },
    тропический_гигант: {
        kg: 40,
        сложение: 'тучное',
        пасть: 'кожистая',
        течение: 'слабое',
        кто: 'арапайма',
    },
};
/** Насколько глубоко крючок вошёл: доля от полного зацепа. */
function зацеп(длинаМ) {
    return Math.min(1, длинаМ / ПОЛНЫЙ_ЗАЦЕП_М);
}
/**
 * ⚠️ ТЕЧЕНИЕ ВХОДИТ ТОЛЬКО В ВЫНОСЛИВОСТЬ, И ЭТО НЕ ЗАБЫВЧИВОСТЬ. Рыба, весь
 * день держащая струю, имеет больше красной мышцы — это меряется и называется
 * критической скоростью. А вот на силу рывка и на то, как она берёт приманку,
 * течение не влияет: жерех на струе и жерех в затоне бьёт одинаково.
 */
const ТЕЧЕНИЕ_ЗАПАС = {
    стоячая: 0.85,
    слабое: 1,
    любое: 1.05,
    сильное: 1.25,
};
/**
 * Посчитать числа боя вида.
 *
 * ⚠️ БЕЗ `сложение` И `пасть` ОТКАТЫВАЕТСЯ НА ПОВАДКУ, А НЕ ПАДАЕТ. Оба поля
 * заполняются подходами по семействам, и до конца работы часть видов их не
 * имеет. Откат даёт те же числа, что были до появления правила, — то есть
 * ничего не ломает и не выдумывает.
 */
export function числаБоя(в) {
    const п = ПОВАДКИ[в.повадка];
    const э = ЭТАЛОНЫ[в.повадка];
    const эС = СЛОЖЕНИЯ[э.сложение];
    const эП = ПАСТИ[э.пасть];
    // Нет признака — берём эталонный: тогда отношение равно единице, и вид
    // получает ровно числа своей повадки, как было до появления правила.
    const с = в.сложение === undefined ? эС : СЛОЖЕНИЯ[в.сложение];
    const пасть = в.пасть === undefined ? эП : ПАСТИ[в.пасть];
    const L = в.typicalLengthM;
    const kg = в.typicalKg;
    /*
     * ⚠️ ВСЁ СЧИТАЕТСЯ ОТНОШЕНИЕМ К ЭТАЛОНУ, А НЕ ПРОИЗВЕДЕНИЕМ. Это не стиль, а
     * единственный способ не посчитать одно дважды: числа повадки уже содержат в
     * себе и форму эталонной рыбы, и её пасть, и её вес.
     */
    const крат = (число, эталон) => (эталон === 0 ? 1 : число / эталон);
    const выносливость = п.staminaS *
        Math.sqrt(kg / э.kg) *
        крат(с.запас, эС.запас) *
        крат(ТЕЧЕНИЕ_ЗАПАС[в.течение] ?? 1, ТЕЧЕНИЕ_ЗАПАС[э.течение] ?? 1);
    const скорость = п.speedMps * крат(с.разгон, эС.разгон);
    return {
        halfThickFrac: с.полутолщина,
        /*
         * ⚠️ РЕЗКОСТЬ И ДЕРЖАНИЕ БЕРУТСЯ ИЗ ПАСТИ НАПРЯМУЮ, А НЕ ОТНОШЕНИЕМ. Это
         * единственные два числа, которых в таблице повадок нет вовсе: `hookMps` там
         * не заведён, а `lipHoldN` — это число эталонной рыбы, то есть та же пасть,
         * записанная дважды. Значения в ПАСТИ подобраны так, что четвёрка выходит
         * точно, и считать их ещё раз через повадку значило бы делить на самого себя.
         */
        hookMps: округлить(пасть.резкость * Math.sqrt(зацеп(L)), 2),
        lipHoldN: Math.round(пасть.держание * зацеп(L)),
        /*
         * ⚠️ СИЛА — ЭТО ПОВАДКА, СЛЕГКА ПОПРАВЛЕННАЯ ФОРМОЙ, А НЕ НАОБОРОТ. Доля
         * формы намеренно мала: выведи силу из одной формы — и окунь получает 1.85
         * вместо замеренных 1.15. Он слаб не потому, что высокотел, а потому, что
         * мелкая стайная рыба.
         */
        strength: округлить(п.strength * (0.6 + 0.4 * крат(с.тяга, эС.тяга)), 2),
        staminaS: округлить(выносливость, 1),
        jumpRate: Math.min(СВЕЧКИ_ПОТОЛОК, п.jumpRate),
        speedMps: округлить(скорость, 2),
        // Полоса остаётся ДОЛЕЙ скорости: сделай её отдельным законом — у медленной
        // мирной рыбы нижняя граница уходит в ноль, и лещ соглашается на стоячую
        // приманку, которую по правилам клёва он и так берёт вчетверо хуже.
        speedBandMps: округлить(скорость * (п.speedBandMps / п.speedMps), 2),
        windowS: округлить(п.windowS * крат(пасть.окно, эП.окно), 1),
    };
}
function округлить(x, знаков) {
    const k = 10 ** знаков;
    return Math.round(x * k) / k;
}
//# sourceMappingURL=fight-numbers.js.map